<template>
  <div>
        <fox-location-history-table fox="alpha"></fox-location-history-table>
        <fox-location-history-table fox="bravo"></fox-location-history-table>
        <fox-location-history-table fox="charlie"></fox-location-history-table>
        <fox-location-history-table fox="delta"></fox-location-history-table>
        <fox-location-history-table fox="echo"></fox-location-history-table>
        <fox-location-history-table fox="foxtrot"></fox-location-history-table>
    </v-container>
  </div>
</template>

<script>
import FoxLocationHistoryTable from '@/components/FoxLocationHistoryTable';

export default {
  name: 'fox-overview',
  mounted() {
      this.$store.dispatch('RETRIEVE_FOX_LOCATIONS');
  },
  components: {
    FoxLocationHistoryTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FoxOverview.vue